import { Injectable } from '@angular/core';

import { AutoOutgoingRule } from '../../models/auto-outgoing-rule';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class AutoOutgoingRuleService extends BackendBaseService {
  url: string = 'auto_outgoing_rules';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  save(autoOutgoingRule: AutoOutgoingRule): Promise<any> {
    return super.save({
      auto_outgoing_rule: autoOutgoingRule,
      id: autoOutgoingRule.id
    });
  }
}
